import { useMutation } from 'react-query'

import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { APIError } from '../../../utils'
import { combineBankLines, createBankLineMatch } from '../query-api'

interface UseAddBankLineToNewMatchProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useAddBankLineToNewMatch = (props?: UseAddBankLineToNewMatchProps) => {
  const { onError, onSuccess } = props || {}

  const addBankLineToNewMatch = async (bankLine: BankLine) => {
    const { bankLineMatches } = await createBankLineMatch({
      accountId: bankLine.accountId,
      entryDate: bankLine.entryDate,
      amount: bankLine.amount,
      side: bankLine.side,
    })

    await combineBankLines({ bankLineId: bankLine.id, matchId: bankLineMatches[0]?.id })
  }

  const {
    mutateAsync: addBankLineToNewMatchAsync,
    isLoading,
    ...rest
  } = useMutation(addBankLineToNewMatch, {
    onSuccess,
    onError,
  })

  return { addBankLineToNewMatchAsync, isProcessing: isLoading, ...rest }
}
